import React from "react";
import { useTranslation } from "react-i18next";
import { BlockingMessageDialog } from "../BlockingMessageDialog";

// v0.6.8 — the delete-run / bulk-delete-runs confirmation used to be a
// native window.confirm() for an irreversible, high-blast-radius
// action ("permanently removes... every transaction... Cannot be
// undone" — bulk delete can remove EVERY uploaded run at once). See
// useRunActions.js's own comment for the full reasoning.
export const RunActionsConfirmDialog = ({ confirmState, onDismiss }) => {
  const { t } = useTranslation();
  return (
    <BlockingMessageDialog
      open={!!confirmState} testid="run-delete-confirm-dialog" severity="error"
      title={t("ui.calculate.delete_confirm_title", { defaultValue: "Delete this permanently?" })}
      onOpenChange={(o) => !o && onDismiss()}
      actions={[
        { label: t("ui.calculate.delete_confirm_cancel", { defaultValue: "Cancel" }), onClick: onDismiss },
        {
          label: t("ui.calculate.delete_confirm_ok", { defaultValue: "Delete" }),
          variant: "primary",
          testid: "run-delete-confirm-ok",
          onClick: () => confirmState?.onConfirm?.(),
        },
      ]}
    ><p>{confirmState?.message}</p></BlockingMessageDialog>
  );
};

export default RunActionsConfirmDialog;
